import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

const searchSchema = z.object({
  locationId: z.string().optional(),
});

/**
 * @purpose Follow material orders through shipment until delivered
 * @primary Order tracking table
 * @persona paola-admin-belora, sports-manager-ikos
 */
export const Route = createFileRoute("/app/c/$customerSlug/tracking/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
